import { ClipLoader } from "react-spinners";

function TutorialCard({
  tutorial,
  editing,
  editValues,
  saveLoadingId,
  deleting,

  handleEdit,
  handleInputChange,
  handleImageChange,
  handleSave,
  handleDeleteClick,
}) {
  const isEditing = editing === tutorial.$id && editValues.type === "tutorial";

  return (
    <div className="product-item">
      <img
        src={tutorial.thumbnailUrl}
        alt={tutorial.tutorialTitle}
        className="product-image"
      />

      {isEditing ? (
        <div>
          <div className="tutorial-yp">
            <p>Name:</p>
            <input
              type="text"
              name="name"
              value={editValues.name}
              onChange={handleInputChange}
            />
          </div>

          <div className="tutorial-yp">
            <p>₹</p>
            <input
              type="number"
              name="cost"
              value={editValues.cost}
              onChange={handleInputChange}
            />
          </div>

          <div className="tutorial-yp">
            <p>Descptn:</p>
            <input
              type="text"
              name="description"
              value={editValues.description}
              onChange={handleInputChange}
              placeholder="Add a description"
            />
          </div>

          <p>Thumbnail:</p>
          <input type="file" accept="image/*" onChange={handleImageChange} />

          <button
            className="save-button"
            onClick={() => handleSave(tutorial)}
            disabled={saveLoadingId === tutorial.$id}
          >
            {saveLoadingId === tutorial.$id ? (
              <ClipLoader size={14} color="#fff" />
            ) : (
              "Save"
            )}
          </button>
        </div>
      ) : (
        <div className="yourprod-details">
          <div className="yourprod-detail">
            <p>Title: </p>
            {tutorial.tutorialTitle}
          </div>

          <div className="yourprod-detail">
            <p>Cost: </p>₹{tutorial.cost}
          </div>
        </div>
      )}

      <div>
        <button
          className="edit-button"
          onClick={() => handleEdit(tutorial, "tutorial")}
        >
          {isEditing ? "Close" : "Edit"}
        </button>

        <button
          className="delete-button"
          onClick={() => handleDeleteClick(tutorial.$id, "tutorial")}
          disabled={deleting === tutorial.$id}
        >
          {deleting === tutorial.$id ? <ClipLoader size={12} /> : "Delete"}
        </button>
      </div>
    </div>
  );
}

export default TutorialCard;
